import { Component, Input } from '@angular/core';
import { Router } from "@angular/router";
import { DashboardResponse } from '../../../api/models/dashboardResponse';

@Component({
    selector: 'cancelled',
    template: require('./dashboardCancelled.component.html')
})

export class CancelledComponent {

    @Input() dataSearch: DashboardResponse;
    @Input() status: any;

    constructor(private router: Router) { }

    searchInformation() {
        // Call API for search Information 
    }

}